import gql from 'graphql-tag'
import JSBI from 'jsbi'

interface V3Tick {
  tick: number | string
  liquidityNet: JSBI | number | string
  price0?: string
  price1?: string
}

export interface AllV3TicksQuery {
  ticksBelow: V3Tick[]
  ticksAbove: V3Tick[]
}

export interface AllV3TicksQueryVariables {
  poolAddress: string
  activeTick: number
}

export const ALL_V3_TICKS_QUERY = gql`
  query AllV3Ticks($poolAddress: String!, $activeTick: BigInt!) {
    ticksBelow: ticks(
      first: 500
      where: { poolAddress: $poolAddress, tickIdx_lte: $activeTick }
      orderBy: tickIdx
      orderDirection: desc
    ) {
      tick: tickIdx
      liquidityNet
      price0
      price1
    }
    ticksAbove: ticks(
      first: 500
      where: { poolAddress: $poolAddress, tickIdx_gte: $activeTick }
      orderBy: tickIdx
      orderDirection: asc
    ) {
      tick: tickIdx
      liquidityNet
      price0
      price1
    }
  }
`

export type Ticks = AllV3TicksQuery['ticksBelow']
export type TickData = Ticks[number]
